<nz-layout class="app-layout">
  <nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
            [nzTrigger]="null">
    <div class="sidebar-logo" *ngIf="!isCollapsed">
      <a routerLink="/dashboard">
        <img class="logo-fold" src="assets/icons/logo.png" alt="Logo" loading="eager">
      </a>
    </div>
    <div class="sidebar-logo" *ngIf="isCollapsed">
      <a routerLink="/dashboard">
        <img class="logo-fold" src="assets/icons/logo-fold.png" alt="Logo">
      </a>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed" class="menu-block">
      <li *ngFor="let item of menu" nz-menu-item nz-tooltip nzMatchRouter class="menu-item"
          [nzTooltipTitle]="isCollapsed ? item.title: ''">
        <i nz-icon nzType="{{item.icon}}" [nzTheme]="'fill'"></i>
        <a [routerLink]="[item.link]" class="menu-link"><span *ngIf="!isCollapsed">{{item.title}}</span></a>
      </li>
    </ul>
    <div class="sidebar-actions">
      <button nz-button nzType="primary" class="mb-4" *ngIf="(user$ | async).role | hasPermission: 'owner'"
              (click)="createSimulation()">
        <i *ngIf="isCollapsed" nz-icon nzType="aim"></i>
        <span *ngIf="!isCollapsed">Create Simulation</span>
      </button>
      <button nz-button nzType="primary" class="mb-4" *ngIf="(user$ | async).role | hasPermission: 'owner'"
              (click)="createDataset()">
        <i *ngIf="isCollapsed" nz-icon nzType="database"></i>
        <span *ngIf="!isCollapsed">Create Dataset</span>
      </button>
    </div>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="updateCollapsed()">
          <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
        </span>
        <div class="right-side">
          <button nz-button nzType="dashed" (click)="logout()" class="logout-btn">Logout</button>
          <nz-avatar [nzGap]="1" [nzText]="initials" nzSize="large" class="user-avatar"></nz-avatar>
        </div>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
